<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M20.3 3a3 3 0 0 0-4.6 0l-.8.7 5.4 5.4.7-.8a3 3 0 0 0 0-4.6zm-1.5 7.6-5.4-5.4-9.8 9.9-.5.8-1 4.8A1 1 0 0 0 3.2 22L8 20.9l.8-.5z"
      clip-rule="evenodd"
    />
  </svg>
</template>
